// Simplified Chinese dictionary. Keys mirror ko.ts exactly.
// NOTE: lore/marketing copy is a first draft — review for brand voice.
export const zh: Record<string, string> = {
  // ── meta ──
  'meta.title': 'DigMol — Dener任命 · 埃尔多拉西亚编年史',

  // ── topbar / wallet ──
  'topbar.become': '成为Dener',
  'wallet.connect': '连接钱包',
  'wallet.connected': '已连接',
  'wallet.copy': '复制',
  'wallet.copied': '已复制！',
  'wallet.myMol': '我的MOL',
  'wallet.denerDash': '我的分销商面板',
  'wallet.admin': '管理员',
  'wallet.disconnect': '断开连接',
  'wallet.roleOwner': 'OWNER',
  'wallet.roleDist': '分销商',
  'wallet.connectCancelled': '钱包连接已取消。',
  'wallet.noWalletFallback': '无法连接钱包。请稍后重试。',
  'wallet.connectFail': '连接失败：{msg}',

  // ── 移动端钱包连接选择（深度链接 / WalletConnect） ──
  'wallet.mobileGuide': '选择钱包进行连接。MetaMask 也可在此连接。',
  'wallet.openInMetaMask': '在 MetaMask 应用中打开（备用）',
  'wallet.retryMetaMask': '重新在 MetaMask 应用中打开',
  'wallet.useMetaMaskApp':
    'MetaMask 应用可能已经打开。请切换到应用继续，或在下方重试。',
  'wallet.otherWallet': '连接其他钱包',
  'wallet.cancel': '关闭',
  'wallet.stuckNotice': '钱包无响应。请刷新页面或重启 MetaMask 应用。',
  'wallet.reload': '刷新',
  'wallet.connectWc': '连接钱包',
  'wallet.preparing': '准备中…',
  'wallet.deadSession': '钱包会话已过期。请刷新页面后重试。',

  // ── 链（网络）警告 ──
  'chain.wrong': '当前网络不是 BNB Smart Chain。需要切换后才能使用。',
  'chain.switch': '切换到 BSC',

  // ── 应用内浏览器（KakaoTalk/LINE/Instagram…）外部浏览器引导 ──
  'inapp.title': '在 {app} 中无法连接钱包',
  'inapp.desc': '出于安全考虑，应用内浏览器无法打开钱包应用。在外部浏览器中打开即可连接。',
  'inapp.open': '在外部浏览器中打开',
  'inapp.copy': '复制链接',
  'inapp.copied': '已复制链接。请粘贴到浏览器中。',
  'inapp.copyFail': '复制失败。请长按地址栏进行复制。',
  'inapp.manualOnly': '不支持自动打开。请复制链接并粘贴到浏览器中。',
  'inapp.justBrowse': '仅浏览',
  'wallet.deeplinkFailed':
    'MetaMask 应用未打开或未连接。请使用下方的 [连接钱包] 继续。',

  // ── language toggle ──
  'lang.toggleAria': '切换语言',

  // ── hero / surface ──
  'alt.mole': 'MolePin鼹鼠',
  'hero.headline': '召唤<br><em>再次守护</em>覆灭王国之人。',
  'hero.tagline': '埃尔多拉西亚正召唤再次守护它的人。',
  'hero.lead':
    '十七个黄金鼹鼠部族的地下王国<b>埃尔多拉西亚</b>。十六个消失后，最后的后裔Molpin重新挖掘。<b>Dener</b>在其身旁守护矿脉，是守护者领袖——而这份任命，始于持有足够的<b>MOL</b>。',
  'hero.scrollcue': '深入矿脉，接受任命',

  // ── lore (section 1) ──
  'lore.eyebrow': '第一层 · Dener是谁',
  'lore.headline': '不是贩卖者，<br>而是<em>守护者</em>。',
  'lore.quote': '“开采矿脉的人很多，守护它的人却很少。”',
  'lore.lead':
    'Dener是为MOL生态做出贡献并证明其价值的<b>守护者领袖</b>。正如鼹鼠Molpin以同族之魂连接锁链，Dener持有足够的MOL以支撑矿脉的稳定。登上此位的流程正是<b style="color:var(--gold)">PV</b> — Dener任命。',
  'lore.pillar1.title': '守护资格',
  'lore.pillar1.desc': '唯有持有2000万MOL者方能被任命为Dener。资格不是权利，而是责任。',
  'lore.pillar1.en': '守护，而非特权。',
  'lore.pillar2.title': '经证明的贡献',
  'lore.pillar2.desc': '任命铭刻于链上。无人能伪造，人人可验证。',
  'lore.pillar2.en': '链上证明，人人可验。',
  'lore.pillar3.title': '开放的矿脉',
  'lore.pillar3.desc': '按既定比率，投入多少就精确开采多少。无议价，无差别。',
  'lore.pillar3.en': '固定比率。绝不议价。',

  // ── steps (section 2) ──
  'steps.eyebrow': '第二层 · 任命之路',
  'steps.headline': '四步，<br>即成<em>守护者</em>。',
  'steps.tagline': '成为Dener的四个步骤。',
  'steps.s1.t': '站在洞口 — 连接钱包',
  'steps.s1.d': '使用MetaMask或兼容钱包连接BSC。手机请在钱包App的内置浏览器中打开。',
  'steps.s2.t': '向矿脉投入BNB',
  'steps.s2.d': '输入要兑换的BNB，即按合约刻定的比率即时计算可开采的MOL。',
  'steps.s3.t': '挥动镐子 — 签名',
  'steps.s3.d': '一次签名。合约按比率将MOL发送到你的钱包。',
  'steps.s4.t': '任命之光升起',
  'steps.s4.d': '当持有的MOL达到2000万的瞬间，Dener资格开启。',

  // ── oath (section 3) ──
  'oath.eyebrow': '第三层 · 矿脉之誓',
  'oath.quote':
    '“合约不议价。<br>投入多少，便按刻定比率——仅此而已。”<span class="src">— THE VEIN, ELDORASIA</span>',
  'oath.lead':
    '这条任命的矿脉与生态中任何其他合约都无牵连。一个比率，一份库存，以及你的签名。因此它能被独立、安全地验证。',

  // ── vein (section 4) ──
  'vein.eyebrow': '最深处 · THE VEIN',
  'vein.headline': '已触及矿脉。',
  'vein.tagline': 'BNB化为MOL之地。守护者诞生之地。',
  'panel.title': 'Dener <em>任命矿脉</em>',
  'panel.subtitle': 'PV INVESTITURE · ISOLATED VEIN',
  'panel.gateLabel': '距Dener任命 — 已持有矿脉',
  'panel.gateLine': '任命线 <b>20,000,000 MOL</b>',

  // ── swap box ──
  'swap.bnbLabel': '投入矿脉的BNB',
  'swap.molOutLabel': '可开采MOL（合约比率）',
  'swap.rateNote': '比率按合约刻定的值计算。',
  'swap.statRate': '合约比率',
  'swap.statStock': '剩余矿脉',
  'swap.statMol': '我的MOL',
  'swap.contractMeta': '设置合约地址后将显示实时比率与库存。',
  'cta.mine': '挥镐 — 开采MOL',

  // ── status / investiture ──
  'status.pending': '○ 未任命',
  'status.dener': '● 已任命Dener',
  'inv.done': '⛏ <b>您已被任命为Dener。</b>已具备矿脉守护者资格。',
  'inv.remaining': '距任命还需再持有<b>{amount} MOL</b>。',

  // ── become-a-dener modal ──
  'modal.title': 'Dener任命<em>仪式</em>',
  'modal.subtitle': 'BECOME A DENER · BNB → MOL',
  'modal.close': '关闭',
  'modal.gateLabel': '距Dener任命',
  'modal.molRangeLabel': '购买MOL数量',
  'modal.molRangeOpt': '（最低2000万）',
  'modal.tick1': '2000万',
  'modal.tick2': '1亿',
  'modal.tick3': '2亿',
  'modal.payLabel': '支付的BNB',
  'modal.priceLoading': '正在加载价格…',
  'modal.distLabel': '选择分销商',
  'modal.distOpt': '（已注册分销商）',
  'modal.distPlaceholder': '例如：alice.dex',
  'modal.outLabel': '将获得MOL',
  'modal.outNote': '选择分销商后将显示折扣数量。',
  'modal.noAddrMeta': '⚠ PV_GATE_ADDRESS 未设置 — .env 中需要 VITE_PV_GATE_ADDRESS',
  'modal.priceNoteNoAddr': '设置合约地址后显示价格。',
  'modal.priceNote': 'MOL {mol} · BNB {bnb}（喂价）',
  'modal.priceFail': '无法加载价格。',
  'modal.needMolAmount': '请设置购买的MOL数量。',
  'modal.noAddrErr': 'PV_GATE_ADDRESS 未设置。',
  'modal.discountChip': '<span class="dk">分销折扣 (+{pct}%)</span><span class="dv">+{extra} MOL</span>',
  'modal.rateBase': '基础 {base} MOL + 折扣 {extra} MOL',
  'modal.rewardLine': '<br>分销商奖励 {rwd} BNB 自动发放',
  'modal.noDiscountReward': '无折扣 · 分销商奖励 {rwd} BNB 自动发放',
  'modal.distHint': '选择分销商后将显示折扣/奖励。',

  // ── 购买者主域名引导（反向解析） ──
  'domain.connectFirst': '请先连接钱包。',
  'domain.checking': '正在确认钱包 {addr} 的主域名…',
  'domain.checkedWallet': '已检查钱包：{addr}',
  'domain.noneTitle': '该钱包未关联主域名。',
  'domain.recheck': '重新检查',
  'domain.have': '✓ 我的主域名：<b>{name}</b>',
  'domain.guideTitle': '申请 Dener 需要一个 dexignation.com 主域名。',
  'domain.step1': '在 dexignation.com 注册一个域名',
  'domain.step2': '将其中一个域名设为主域名',
  'domain.step3': '返回并继续申请 Dener',
  'domain.link': '前往 dexignation.com ↗',

  // ── distributor address validation ──
  'dist.valid': '✓ 有效分销商 — 购买者折扣 {disc}% · 分销商奖励 {rwd}%',
  'dist.validName': '✓ {name} → {addr} · 购买者折扣 {disc}% · 分销商奖励 {rwd}%',
  'dist.inactive': '分销商未激活。将无折扣继续。',
  'dist.notRegistered': '不是已注册的分销商。将无折扣继续。',
  'dist.required': '需输入有效的 .dex 域名才能继续任命。',
  'dist.requiredBadge': '必填',
  'dist.requiredHint': '折扣 .dex 域名为必填项。',
  'dist.notDexName': '请输入 .dex 名称（例如：alice.dex）',
  'dist.resolving': '正在解析名称…',
  'dist.nameNotFound': '该名称未注册。',
  'dist.noBnbAddr': '该名称未关联BNB地址。',
  'dist.resolveError': '解析名称时出错。请稍后重试。',
  'dist.loadingDistributors': '正在加载分销商列表…',
  'dist.selectPlaceholder': '请选择分销商',
  'dist.selectRequired': '必须选择分销商。',
  'dist.selectedDistributor': '✓ {name} · Dener 折扣 {disc}% · 分销商奖励 {rwd}%',
  'dist.selectedInactiveDistributor': '分销商未激活：{name}。将无折扣继续。',
  'dist.selectInvalid': '无法使用所选分销商。',
  'dist.noDistributors': '暂无注册的分销商。',
  'dist.listError': '无法加载分销商列表。请稍后重试。',

  // ── distributor dashboard ──
  'dener.title': '我的<em>分销商</em>面板',
  'dener.subtitle': 'DISTRIBUTOR DASHBOARD',
  'dener.discLabel': '购买者折扣',
  'dener.rwdLabel': '我的奖励',
  'dener.statusLabel': '状态',
  'dener.setLabel': '设置我的折扣率',
  'dener.setOpt': '（0–15%，奖励自动）',
  'dener.apply': '应用折扣率（签名）',
  'dener.lockedText': '🔒 管理员已设置折扣率/奖励率。如需更改请联系管理员。',
  'dener.buyersHead': '选择我为分销商的购买者',
  'dener.active': '已激活',
  'dener.inactive': '未激活',
  'dener.autoHint': '→ 我的奖励 {n}%',
  'dener.signConfirm': '请确认签名…',
  'dener.applied': '✓ 折扣率 {pct}% 已应用',
  'dener.buyerCount': '{n}人',
  'dener.noBuyers': '还没有人通过我购买。',
  'dener.buyersFail': '查询失败（可能是RPC限制）',

  // ── admin overlay ──
  'admin.title': '管理员 — <em>分销商管理</em>',
  'admin.subtitle': 'OWNER ADMIN',
  'admin.regPlaceholder': '分销商 .dex 名称或钱包地址',
  'admin.regBtn': '+ 注册',
  'admin.regRequired': '请输入要注册的分销商 .dex 名称或钱包地址。',
  'admin.regInvalid': '请输入 .dex 名称或 0x 钱包地址。',
  'admin.regAddressOk': '✓ 钱包地址已确认：{addr}',
  'admin.regResolved': '✓ {name} → BNB {addr}',
  'admin.detailEmpty': '← 请选择分销商',
  'admin.dBuyersK': '购买者数',
  'admin.dDiscK': '折扣',
  'admin.dRwdK': '奖励',
  'admin.activeTitle': '激活分销商',
  'admin.activeDescDefault': '激活后将应用该分销商的折扣·奖励',
  'admin.lockTitle': '管理员锁定',
  'admin.lockDescDefault': '锁定：仅管理员设置 / 解除：分销商本人设置',
  'admin.discRangeLabel': 'Dener 折扣率',
  'admin.rwdRangeLabel': '分销商奖励率',
  'admin.apply': '以此折扣率·奖励率设置（管理员锁定）',
  'admin.remove': '删除分销商',
  'admin.noDistributors': '暂无注册的分销商。<br>请在上方用 .dex 名称或钱包地址注册。',
  'admin.listRates': '折扣 {disc}% · 奖励 {rwd}% · <span class="{cls}">{status}</span>',
  'admin.activeDescOn': '已激活 — 折扣·奖励生效',
  'admin.activeDescOff': '未激活 — 折扣·奖励不生效',
  'admin.lockDescOn': '已锁定 — 仅管理员可设置折扣率',
  'admin.lockDescOff': '已解除 — 分销商本人可设置折扣率',
  'admin.regSign': '请确认注册签名…',
  'admin.registered': '✓ 已注册',
  'admin.setSign': '请确认设置签名…',
  'admin.ratesSet': '✓ 已设置（锁定）',
  'admin.toggleSign': '确认签名…',
  'admin.activated': '激活',
  'admin.deactivated': '停用',
  'admin.toggleResult': '✓ 已{state}',
  'admin.lockApplied': '✓ 管理员锁定（折扣 {disc}% / 奖励 {rwd}%）',
  'admin.released': '✓ 已切换为分销商自管',
  'admin.removeSign': '请确认删除签名…',
  'admin.removed': '✓ 已删除',

  // ── footer ──
  'footer.brand': 'Dig<em>Mol</em> — Dener任命之矿脉',
  'footer.line1': '埃尔多拉西亚编年史 · PV任命专用隔离兑换合约',
  'footer.tag': 'DigMolPvGate · 独立部署 · 与主生态无关',
  'footer.disc': '本页所有信息仅供参考，并非投资建议。© 2026 MolePin Community',

  // ── contract / refresh ──
  'contract.noAddr': '⚠ PV_GATE_ADDRESS 未设置 — 在 .env 中加入 VITE_PV_GATE_ADDRESS 即可启用真实兑换。',
  'contract.vein': '矿脉 {link}',
  'refresh.rateNote': 'MOL {mol} · BNB {bnb} · 剩余矿脉 {stock} MOL',
  'refresh.queryFail': '合约查询失败：{msg}',

  // ── swap flow ──
  'swap.needAmount': '请输入要投入矿脉的BNB数量。',
  'swap.noAddr': 'PV_GATE_ADDRESS 未设置（需输入部署地址）。',
  'swap.failPrefix': '开采失败：{msg}',

  // ── tx states ──
  'tx.signing': '请在钱包中确认签名…',
  'tx.pendingMining': '镐子凿击矿脉…等待确认',
  'tx.confirming': '等待区块确认…',
  'tx.successDefault': '完成',
  'tx.successMined': '⛏ 开采成功 — 已采得 <b>{got}</b>',
  'tx.viewTx': '查看交易 ↗',

  // ── error maps ──
  'err.userRejected': '签名被拒绝。',
  'err.insufficientBnb': 'BNB余额不足（兑换额+手续费）。',
  'err.insufficientStock': '矿脉的MOL库存不足。请稍后重试。',
  'err.gateClosed': '矿脉当前已关闭。',
  'err.zeroAmount': '金额为0。',
  'err.noGateAddr': '合约地址未设置。',
  'err.tx.userCancelled': '您在钱包中取消了签名。',
  'err.tx.insufficientGas': '手续费（BNB）不足。请在钱包中补充BNB。',
  'err.tx.notOwner': '无权限（请使用owner钱包执行）。',
  'err.tx.notDist': '不是已注册的分销商。',
  'err.tx.ownerLocked': '该分销商已被管理员锁定，无法更改。',
  'err.tx.badDiscount': '折扣率超出范围（0–15%）。',
  'err.tx.badReward': '奖励率超出范围（0–5%）。',
  'err.tx.network': '网络错误。请稍后重试。',
  'err.tx.unknown': '处理时出现问题。请稍后重试。',

  // ── ticker feed messages ──
  'feed.msg1': '一位新的守护者加入了王国',
  'feed.msg2': '一位Dener获得了任命',
  'feed.msg3': '守护者降临覆灭的王国',
  'feed.msg4': '埃尔多拉西亚又亮起一束光',
  'feed.msg5': '手持镐子的守护者出现了',

  // ── shared ──
  'common.loading': '加载中…',
  'common.txLink': 'tx ↗',
  'common.queryFail': '查询失败',
};
